import { TFunction } from 'i18next'
import { countryCodes } from '../../constants/countries'
import { sanitizeToLatin } from '../utils'
import { Emc, InstallationFormModel, Storage, StorageSystem } from './installation-form-model'

export const getDefaultInstallation = (t: TFunction): InstallationFormModel => {
  return {
    id: null,
    name: sanitizeToLatin(t('installation.projectNameDefault')),
    emcDevice: null,
    storageDevices: [],
    gpsLatitude: '',
    gpsLongitude: '',

    generalSettings: {
      location: {
        street: '',
        houseNumber: '',
        postalCode: '',
        location: '',
        country: countryCodes.germany,
        timeZone: 'Europe/Berlin',
      },

      gridSettings: {
        numberOfPhases: 'three-phases',
        mainProtection: 63,
        thermalDerating: 50,

        gridMeter: {
          hasElectricalCurrentTransformer: false,
          electricalCurrentTransformerRatio: '400:5',
        },
      },
    },
    storageSystem: getDefaultStorageSystem(),
    chargingStations: {
      modbusTcp: [],
      eebus: [],
    },
    chargingStationsExpandedState: {
      modbusTcp: {},
      eebus: {},
    },
    heatpump: null,
    meters: [],
    ioInterfaces: {
      htc320h: null,
      storage: null,
      mypv: null,
    },
  }
}

export const getDefaultStorageSystem = (emcDevice?: Emc | null, storageDevices?: Storage[]): StorageSystem => {
  return {
    generalSettings: {
      wiringTopologyDeviceId: Number(emcDevice?.deviceId),

      systemRegulation: {
        peakPower: 1800,
        hasFeedInLimit: false,
        feedInRatio: 70,
        feedInMaxPower: 12600,
      },

      chargingConfiguration: {
        priorityChargingDevice: 'charging station',
        useBatteryDischargeOnlyWhenPvIsExceeded: false,
        useBatteryDischargeOnlyInOtherMode: false,
      },

      advancedSettings: {
        weatherForecastOptimization: {
          useWeatherForecastBasedCharging: true,
          weatherOptimizationOption: 'Heat pump via SG-Ready',
        },
        emergencyPower: {
          useEmergencyPower: true,
          emergencyPowerDelay: 5,
        },

        chargeBlockingWeeklySchedule: [],

        dischargeBlockingWeeklySchedule: [],
      },
    },

    storageSpecificSettings: storageDevices?.map(storageDevice => {
      const isStorageR1 = storageDevice.deviceType === 'XEM - R1'

      return {
        deviceId: storageDevice.deviceId,

        chargingConfiguration: {
          trackersBehaviour: 'duo tracker',
        },

        advancedSettings: {
          batteryNumber: null,

          batteryOperationRange: {
            isStorageSingleBattery: false,
            isAuto: true,
            maximumChargingPower: isStorageR1 ? 3000 : 4500,
            maximumDischargingPower: isStorageR1 ? 3000 : 4500,
            minimumConsumptionPowerToStartDischarge: 50,
          },

          emergencyPower: {
            emergencyPowerReserve: 500,
          },

          useStorageSystemEnergySavingMode: true,
        },
      }
    }) || [
      {
        deviceId: null,

        chargingConfiguration: {
          trackersBehaviour: 'duo tracker',
        },

        advancedSettings: {
          batteryNumber: null,

          batteryOperationRange: {
            isStorageSingleBattery: false,
            isAuto: true,
            maximumChargingPower: 4500,
            maximumDischargingPower: 4500,
            minimumConsumptionPowerToStartDischarge: 50,
          },

          emergencyPower: {
            emergencyPowerReserve: 500,
          },

          useStorageSystemEnergySavingMode: true,
        },
      },
    ],
  }
}
